"use client"

import { Component, ReactNode } from "react"

type WidgetErrorBoundaryProps = {
  fallback: ReactNode
  children: ReactNode
}

type WidgetErrorBoundaryState = { hasError: boolean }

/**
 * Isolates a single risky embed/third-party widget so its render failure
 * degrades locally instead of propagating to the nearest route-level
 * error.tsx and blanking the whole page.
 */
export class WidgetErrorBoundary extends Component<
  WidgetErrorBoundaryProps,
  WidgetErrorBoundaryState
> {
  state: WidgetErrorBoundaryState = { hasError: false }

  static getDerivedStateFromError(): WidgetErrorBoundaryState {
    return { hasError: true }
  }

  componentDidCatch(error: Error) {
    console.error("Widget failed to render:", error)
  }

  render() {
    return this.state.hasError ? this.props.fallback : this.props.children
  }
}
